interface FilteredEmptyStateProps {
  show: boolean
  onReset: () => void
}

export default function FilteredEmptyState({ show, onReset }: FilteredEmptyStateProps) {
  if (!show) return null

  return (
    <div className="mx-3 mb-3 flex flex-wrap items-center justify-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-600">
      <span>No records match these filters.</span>
      <button type="button" onClick={onReset} className="font-medium text-red-800 hover:text-red-950">
        Reset filters
      </button>
    </div>
  )
}